import { render, staticRenderFns } from "./responseDetail.vue?vue&type=template&id=107f9574&scoped=true&"
import script from "./responseDetail.vue?vue&type=script&lang=js&"
export * from "./responseDetail.vue?vue&type=script&lang=js&"
import style0 from "./responseDetail.vue?vue&type=style&index=0&id=107f9574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f9574",
  null
  
)

export default component.exports